import { Box, Typography, useTheme, Paper } from "@mui/material";
import { capitalizeFirstChar } from "../utils/textUtils";
import { useAuth } from "../context/connectionContext";
import CopyableTextPaper from "./CopyableTextPaper";
import { useUserData } from "../context/userContext";
import { generateHelpLink } from "../utils/generateHelpLink";
import ShareMenu from "./ShareMenu";
import QRDialogContent from "./QRDialogContent";
import { useState } from "react";

const RecoveryMode = () => {
  const theme = useTheme();
  const { account } = useAuth();
  const { name } = useUserData();
  const [showQRCode, setShowQRCode] = useState(false);
  const helpLink = generateHelpLink({ account, accountName: name });

  return (
    <Box
      sx={{
        minHeight: "90vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 1, sm: 2, md: 3 },
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: "100%",
          maxWidth: 420,
          p: { xs: 2, sm: 4 },
          borderRadius: 4,
          boxShadow: "0 4px 32px 0 rgba(0,0,0,0.10)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 2, sm: 3 },
          margin: "0 auto",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            textAlign: "center",
            color: theme.palette.primary.main,
            mb: { xs: 1, sm: 2 },
          }}
        >
          {capitalizeFirstChar(`${name} is being recovered`)}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            textAlign: "center",
            mb: 1,
          }}
        >
          To complete recovery, share this link with your helpers to recover:
        </Typography>
        {/* Copyable address with share button */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
            width: "100%",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <CopyableTextPaper text={helpLink || ""} />
          </Box>

          <ShareMenu value={helpLink || ""} handleShowQRCode={() => setShowQRCode(true)} />
        </Box>
        {/* <Box sx={{ width: '100%' }}>
              <CopyableTextPaper text={helpLink} />
            </Box> */}
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: theme.palette.primary.dark,
            textAlign: "center",
            mt: 1,
          }}
        >
          View rcovery status on the mobile app.
        </Typography>
      </Paper>
      {/* QR Code Dialog */}
      <QRDialogContent
        open={showQRCode}
        handleClose={() => setShowQRCode(false)}
        title="Scan QR Code"
        instruction="Scan this QR code with another device to get the recovery link"
        enableCopy={true}
        value={helpLink || ""}
        valueLabel="Recovery Link"
        showQrCodeValue={true}
      />
    </Box>
  );
};

export default RecoveryMode;
